export { default } from "./ImagesManagement.container";
